<template>
    <AppHeader />
    <NuxtPage />
</template>

  <style>
  @import url("~/assets/css/global.css");
  @import url("~/assets/css/main.css");
  </style>
